export default "__VITE_ASSET__BDCat0Lw__"